// WordPress dependencies
import { Panel } from "@wordpress/components";

// Internal dependencies
import ImageContentTab from "../panels/ImagesContentTab";
import IndicatorImageContentTab from "../panels/IndicatorImageContentTab";
import SettingsContentTab from "../panels/SettingsContentTab";

export default (props) => {
    const isTripleEnabled = !!props.proSettings.is_triple_active;
    const sliderType = props.attributes.slider_type;
    const isTriple = isTripleEnabled && sliderType === "triple";

    return (
        <Panel>
            <ImageContentTab {...props} />
            {/* {!isTriple && <IndicatorImageContentTab {...props} />} */}
            <SettingsContentTab {...props} />
        </Panel>
    );
};
